<template>
    <div>
        <div class="row">
            <div class="col card">
                <div class="card-body">
                    <h5>Apps and APIs Setup </h5>
                    <p>You can configure apis and apps on this page </p>
                </div>
            </div>
        </div>
        <div class="products-list row">
            <div v-for="(app, index) in apps"
                 :key="index"
                 class="col-md-4"
                 :class="[alreadySetUp(app.slug) ? 'blue-border' : '']">
                <div class="product-card  product-body">
                    <div class="app-icon p-shrink"
                         :style="`background-color: ${app.meta.color}`">
                        <div class="p-shrink product-title">
                            <h6 class=""><b>{{ app.name }}</b></h6>
                        </div>
                        <!-- <span :uk-icon="app.icon"></span> -->
                        <i class="material-icons">
                            {{ app.meta.icon }}
                        </i>
                    </div>
                    <div class="p-shrink product-description">
                        <p class="">{{ app.description }}</p>
                    </div>
                    <div class="p-shrink product-action">
                        <el-tag type="warning"
                                v-if="!app.active">
                            Coming soon ...
                        </el-tag>

                        <button v-if="app.active && !alreadySetUp(app.slug)"
                                class="btn btn-success btn-sm"
                                @click="goTo(app.slug)">
                            Setup
                            <i class="el-icon-right"/>
                        </button>

                        <el-tag type="success" v-if="alreadySetUp(app.slug)">
                            Done <i class="el-icon-success"/>
                        </el-tag>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import {axios} from '../../../bootstrap'

    export default {
        data() {
            return {};
        },
        mounted() {
            this.$store.dispatch('getApiProducts')
        },
        computed: {
            apps() {
                return this.$store.getters.getProducts.filter(app => {
                    return app.access === 'public' || this.alreadySetUp(app.slug) || this.$hasRole('admin')
                }).map(app => {
                    if (app.meta === null) {
                        app.meta = {
                            icon: 'dashboard',
                            color: '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
                        }
                    }
                    return app;
                })
            }
        },
        methods: {
            alreadySetUp(slug) {
                return _.includes(this.project.apis, slug);
            },

            goTo(app) {
                switch (app) {
                    case 'chat':
                    case 'bulk-sms':
                        this.$router.push({
                            name: `onboarding-${app}`,
                            params: {
                                project: this.project.id
                            }
                        });
                        break;
                    default:
                        axios.post(`web/projects/${this.project.id}/products/on-boarding`, {
                            product: app
                        }).then(() => {
                            this.$router.push(`/projects/${this.project.id}/overview`)
                        });
                        break;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .col-md-4 {
        margin-bottom: 60px;
        padding-right: 20px;
    }

    .card {
        padding: 20px;
        margin-top: 30px;
    }

    .products-list {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-content: space-around;
    }

    .product-card {
        background-color: #ffffff;
        border-radius: 10px;
        border: 1px solid #eef;
        width: 100%;
        height: 100%;
        margin-bottom: 20px;
        flex: 1 0;
        cursor: pointer;
    }

    .product-card:hover {
    }

    .product-title {
        font-size: 13px;
        font-weight: bold;
        color: #2a2a90bf;
    }

    .product-body {
        width: 100% !important;
        /*padding: 10px 10px 20px 10px;*/
    }

    .app-icon {
        width: 100%;
        border-radius: 5px 5px 0 10px;
        padding: 20px;
        display: flex;
        flex: 1;
    }

    .product-description {
        padding: 20px 20px 10px 20px;
        font-size: 13px;
        text-align: justify-all;
        flex: 1;
        margin-bottom: 20px;
    }

    .blue-border {
        border-color: #277bd9 !important;
        box-shadow: none;
    }

    .product-action {
        padding: 5px 20px 10px 20px;
        position: absolute;
        bottom: 10px;
    }

    .p-shrink {
        flex: 1;
    }
</style>
